import { z } from 'zod'

export interface VisitorParkingSessionModel {
  totalPaid: number
  ticketNumber: string
  phoneNumber: number
  name: string
  licensePlate: string
  email: string
  checkIn: number
  checkOut: number
}

export const VisitorParkingPricingEntrySchema = z.object({
  duration: z.number(),
  enabled: z.boolean(),
  // Note: Price in dollars
  price: z.string(),
})
export type VisitorParkingPricingEntry = z.infer<typeof VisitorParkingPricingEntrySchema>

export const VisitorParkingApiPricingEntrySchema = z.object({
  duration: z.number(),
  enabled: z.boolean(),
  // Note: Price in cents
  price: z.number(),
})
export type VisitorParkingApiPricingEntry = z.infer<typeof VisitorParkingApiPricingEntrySchema>
